import {DialogManager} from '@modifi/plugin-dialogs'
import {WrappedAdminDialogLayout} from '../layout/dialog-layout'

import ConfirmMatchDialog, {
  DIALOG_NAME as DIALOG_CONFIRM_MATCH,
} from '../features/match/components/confirm-match-dialog'

import SplitTransactionDialog, {
  DIALOG_NAME as DIALOG_SPLIT_TRANSACTION,
} from '../features/transactions/dialogs/split-transaction-dialog'

import DeleteTransactionDialog, {
  DIALOG_NAME as DIALOG_DELETE_TRANSACTION,
} from '../features/transactions/dialogs/delete-transaction-dialog'

import SpvRemovalDialog, {
  DIALOG_NAME as DIALOG_SPV_REMOVAL,
} from '../features/transactions/dialogs/spv-removal-dialog'

import EditTransactionDialog, {
  DIALOG_NAME as DIALOG_TAG_TRANSACTION,
} from '../features/transactions/dialogs/edit-transaction-dialog'

import ManageDocumentsDialog, {
  DIALOG_NAME as DIALOG_MANAGE_DOCUMENTS,
} from '../features/transactions/dialogs/manage-documents-dialog'

import PassThroughTransactionDialog, {
  DIALOG_NAME as DIALOG_PASS_THROUGH_TRANSACTION,
} from '../features/transactions/dialogs/pass-through-transaction-dialog'

import UpdateTransactionSuccessDialog, {
  DIALOG_NAME as DIALOG_PASS_THROUGH_TRANSACTION_SUCCESS,
} from '../features/transactions/dialogs/update-transaction-success'

import BulkMatchingDialog, {
  DIALOG_NAME as DIALOG_BULK_MATCHING,
} from '../features/transactions/dialogs/bulk-matching-dialog'

DialogManager.setDefaultLayout(WrappedAdminDialogLayout)
DialogManager.addDialog(DIALOG_CONFIRM_MATCH, ConfirmMatchDialog, {
  layoutProps: {
    fluid: true,
  },
})
DialogManager.addDialog(DIALOG_DELETE_TRANSACTION, DeleteTransactionDialog, {
  layoutProps: {
    size: {
      lg: 10,
      md: 11,
      col: 12,
    },
  },
})
DialogManager.addDialog(DIALOG_SPLIT_TRANSACTION, SplitTransactionDialog, {
  layoutProps: {
    size: {
      lg: 10,
      md: 11,
      col: 12,
    },
    fluid: true,
  },
})
DialogManager.addDialog(DIALOG_SPV_REMOVAL, SpvRemovalDialog, {
  layoutProps: {
    size: {
      lg: 10,
      md: 11,
      col: 12,
    },
  },
})
DialogManager.addDialog(DIALOG_TAG_TRANSACTION, EditTransactionDialog, {
  layoutProps: {
    size: {
      lg: 10,
      md: 11,
      col: 12,
    },
  },
})
DialogManager.addDialog(DIALOG_MANAGE_DOCUMENTS, ManageDocumentsDialog, {
  layoutProps: {
    size: {
      lg: 10,
      md: 11,
      col: 12,
    },
  },
})
DialogManager.addDialog(DIALOG_PASS_THROUGH_TRANSACTION, PassThroughTransactionDialog, {
  layoutProps: {
    size: {
      lg: 10,
      md: 11,
      col: 12,
    },
  },
})
DialogManager.addDialog(DIALOG_PASS_THROUGH_TRANSACTION_SUCCESS, UpdateTransactionSuccessDialog, {
  layoutProps: {
    size: {
      lg: 10,
      md: 11,
      col: 12,
    },
  },
})
DialogManager.addDialog(DIALOG_BULK_MATCHING, BulkMatchingDialog, {
  layoutProps: {
    size: {
      lg: 10,
      md: 11,
      col: 12,
    },
  },
})
